import { createSelector } from '@ngrx/store';

import { getBaseState } from '../reducers';

export const getAuthState = createSelector(getBaseState, state => state.auth);

export const getLoginError = createSelector(
  getAuthState,
  state => state.loginError
);

export const getRequestPasswordResetActionState = createSelector(
  getAuthState,
  state => state.requestPasswordResetActionState
);

export const getResetPasswordActionState = createSelector(
  getAuthState,
  state => state.resetPasswordActionState
);

export const getEmailVerifiedInCurrentSession = createSelector(
  getAuthState,
  state => state.emailVerifiedInCurrentSession
);

export const getIsLoading = createSelector(
  getAuthState,
  state => state.isLoading
);
